import Axios, { AxiosRequestConfig } from 'axios';
import {
  URL_BACKEND_ROOT
} from "../app/AppConst";
import AuthUtility from "../util/AuthUtility";
import { KycTextEntity } from '../dto/kyc/KycTextEntity';
import { BaseResponse } from '../dto/response/BaseResponse';
import { ReadResponse } from '../dto/response/ReadResponse';
import { AccountHistorySearch } from '../dto/accounthistory/AccountHistorySearch';
import { UserModel } from '../dto/User/UserModel';
import { UserEntity } from '../dto/User/UserEntity';
import { UserSearch } from '../dto/User/UserSearch';
import { AccountDetailEntity } from '../dto/account/AccountDetailEntity';
import { ApiClient } from '../util/ApiUtility';
import { KycCaseEntity } from '../dto/kyc/KycCaseEntity';
import { AccountBankEntity } from '../dto/account/AccountBankEntity';

export const onUserSearch = async (data: UserSearch) => {
  const requestConfig: AxiosRequestConfig = {
      headers: {
      'Content-Type': 'application/json',
      },
      method: 'GET',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/account/search',
      params: {
        name: data.name,
        phoneNo: data.phoneNo,
        regNo: data.regNo,
        type: data.type,
        email: data.email,
        offset: data.offset,
        limit: data.limit
    }
  }

  const response = await ApiClient().request<ReadResponse>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
      return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onUserDetail = async (data: string) => {
  const requestConfig: AxiosRequestConfig = {
      headers: {
      'Content-Type': 'application/json',
      },
      method: 'GET',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/account?detail=' + data
  }
  const response = await ApiClient().request<BaseResponse<AccountDetailEntity>>(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onUserKycAccept = async (kycId: number) => {
  const requestConfig: AxiosRequestConfig = {
      headers: {
      'Content-Type': 'application/json',
      },
      method: 'GET',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/kyc/accept?kycId=' + kycId
  }
  const response = await ApiClient().request<BaseResponse<KycCaseEntity>>(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onUserKycReject = async (kyc: KycCaseEntity) => {
  const requestConfig: AxiosRequestConfig = {
      headers: {
      'Content-Type': 'application/json',
      },
      method: 'POST',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/kyc/reject',
      data: kyc
  }
  const response = await ApiClient().request<BaseResponse<KycCaseEntity>>(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onKyc = async (userKyc: UserModel) => {
  const requestConfig: AxiosRequestConfig = {
      headers: {
      'Content-Type': 'application/json',
      },
      method: 'POST',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/user/command',
      data: userKyc
  }
  const response = await ApiClient().request<BaseResponse<UserEntity>>(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onKycText = async (data: KycTextEntity) => {
  const requestConfig: AxiosRequestConfig = {
      headers: {
      'Content-Type': 'application/json',
      },
      method: 'POST',
      url: `${URL_BACKEND_ROOT}` + '/v1/uaa/user/kyc-id-text',
      data
  }
  const response = await ApiClient().request(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onUserBankStatusUpdate = async (accountBank: AccountBankEntity) => {
  const requestConfig: AxiosRequestConfig = {
      headers: {
      'Content-Type': 'application/json',
      },
      method: 'POST',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/account/bank/update',
      data: accountBank
  }
  const response = await ApiClient().request<BaseResponse<AccountBankEntity>>(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onUserBanks = async (userId?: number) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/finance/user-bank',
    params: {
      userId: userId
    }
  }
  const response = await ApiClient().request<ReadResponse>(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onUserFiatAccount = async (userId?: number) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/wallet',
    params: {
      type: 'USER_FIAT',
      referenceId: userId,
      fiatCode: 'MNT'
    }
  }
  const response = await ApiClient().request<ReadResponse>(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onUserAccountHistory = async (accountHistorySearch: AccountHistorySearch) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/wallet/history',
    params: {
      userId: accountHistorySearch.userId,
      fiatAccountId: accountHistorySearch.fiatAccountId,
      limit: accountHistorySearch.limit,
      offset: accountHistorySearch.offset
    }
  }
  const response = await ApiClient().request<ReadResponse>(requestConfig); 

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onIdConfirm = async (data: UserModel) => {
  const requestConfig: AxiosRequestConfig = {
      headers: {
      'Content-Type': 'application/json',
      },
      method: 'POST',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/user/command',
      data
  }
  const response = await ApiClient().request<BaseResponse<UserEntity>>(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onNationalIdStatusChange = async (data: UserModel) => {
  const requestConfig: AxiosRequestConfig = {
      headers: {
      'Content-Type': 'application/json',
      },
      method: 'POST',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/user/command',
      data
  }
  const response = await ApiClient().request<BaseResponse<UserEntity>>(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const getUserAddresses = async (data: number) => {
  const requestConfig: AxiosRequestConfig = {
      headers: {
      'Content-Type': 'application/json',
      },
      method: 'GET',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/account/addresses?account=' + data
  }
  const response = await ApiClient().request<BaseResponse<any>>(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}